(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", ], factory);
	else if(typeof exports === 'object')
		exports["prijscalculator-app"] = factory(require("axios"), require("vue"));
	else
		root["prijscalculator-app"] = factory(root["axios"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3300__, __WEBPACK_EXTERNAL_MODULE__7203__) {
return 